// ==========================================================================
// components/ui.tsx — the few shared building blocks (FF-003, 9 Oct 2026)
// Keep this small; real screens get their own components.
// ==========================================================================
import type { ButtonHTMLAttributes, InputHTMLAttributes, ReactNode } from "react";

export function Card({ children, className = "" }: { children: ReactNode; className?: string }) {
  return <section className={`rounded-lg bg-surface shadow-soft ring-1 ring-line/70 p-5 ${className}`}>{children}</section>;
}

export function Button({ className = "", variant = "primary", ...rest }: ButtonHTMLAttributes<HTMLButtonElement> & { variant?: "primary" | "ghost" }) {
  const base = "w-full rounded-md px-4 py-3 text-base font-semibold transition disabled:opacity-50 disabled:cursor-not-allowed";
  const look = variant === "primary" ? "bg-primary text-primary-ink hover:opacity-90" : "bg-transparent text-ink-muted hover:text-ink";
  return <button className={`${base} ${look} ${className}`} {...rest} />;
}

export function Field({ label, ...rest }: InputHTMLAttributes<HTMLInputElement> & { label: string }) {
  return (
    <label className="block space-y-1">
      <span className="text-sm font-medium text-ink-muted">{label}</span>
      <input
        className="w-full rounded-md border border-line bg-bg px-3 py-3 text-base text-ink outline-none focus:border-primary"
        {...rest}
      />
    </label>
  );
}

export function ErrorText({ children }: { children: ReactNode }) {
  if (!children) return null;
  return <p className="text-sm text-bad">{children}</p>;
}
